function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isBlank = function isBlank(str) {
  return !str && str !== 0 || typeof str === 'string' && str.trim().length === 0;
};

var get = function get(p, o) {
  return p.reduce(function (xs, x) {
    return xs && !isBlank(xs[x]) ? xs[x] : null;
  }, o);
};

var simpleLookup = function simpleLookup(path, data) {
  return get(path.split('.'), data);
};

var transformValue = function transformValue(value, transform) {
  switch (transform.type) {
    case 'replace':
      return transform.map[value] ? transform.map[value] : value;

    case 'lowercase':
      return value.toLowerCase();

    case 'regex':
      {
        var pattern = RegExp(transform.pattern, 'g');
        return value.replace(pattern, transform.replaceWith);
      }

    default:
      return value;
  }
};

var processBranchOfDataLayer = function processBranchOfDataLayer(node, datalayer) {
  return Object.keys(node).reduce(function (obj, mappingKey) {
    var mappingValue = node[mappingKey];

    if (typeof mappingValue === 'string') {
      obj[mappingKey] = simpleLookup(mappingValue, datalayer);
    } else if (_typeof(mappingValue) === 'object') {
      var originalValue = simpleLookup(mappingValue.sourceValue, datalayer);

      if (mappingValue.transforms && originalValue) {
        obj[mappingKey] = mappingValue.transforms.reduce(transformValue, originalValue);
      } else {
        obj[mappingKey] = originalValue;
      }
    }

    if (isBlank(obj[mappingKey])) {
      if (mappingValue.defaultValue) {
        obj[mappingKey] = mappingValue.defaultValue;
      } else {
        delete obj[mappingKey];
      }
    }

    return obj;
  }, {});
};

var getMappingRuleIndex = function getMappingRuleIndex(_ref, datalayer) {
  var name = _ref.name,
      sourceValue = _ref.sourceValue;
  return simpleLookup("".concat(name, ".").concat(sourceValue), datalayer);
};

var getMappings = function getMappings(schemaMappings, branch, datalayer) {
  var _ref2 = schemaMappings[getMappingRuleIndex(branch, datalayer)] || schemaMappings[branch.defaultValue] || {
    mappings: {}
  },
      mappings = _ref2.mappings,
      inherit = _ref2.inherit;

  while (inherit) {
    mappings = Object.assign({}, schemaMappings[inherit].mappings, mappings);
    inherit = schemaMappings[inherit].inherit;
  }

  return mappings;
};

var processTreeBranches = function processTreeBranches(targetingMapping, treeBranches, datalayer) {
  return treeBranches.reduce(function (obj, branch) {
    var mappedBranch = processBranchOfDataLayer(getMappings(targetingMapping.dataLayerSchemaMappings, branch, datalayer), datalayer);
    return _objectSpread(_objectSpread({}, obj), mappedBranch);
  }, {});
};

var processRequiredMappings = function processRequiredMappings(targetingMapping, appName, pageId, datalayer) {
  return processTreeBranches(targetingMapping, simpleLookup("systems.".concat(appName, ".").concat(pageId, ".requiredMappings"), targetingMapping) || [], datalayer);
};

var processStaticMappings = function processStaticMappings(targetingMapping, appName, pageId) {
  return simpleLookup("systems.".concat(appName, ".").concat(pageId, ".staticMappings"), targetingMapping) || {};
};

var generateCoreTargeting = function generateCoreTargeting(targetingMapping, datalayer) {
  return processTreeBranches(targetingMapping, targetingMapping.core.requiredMappings, datalayer);
};

var generatePageTargeting = function generatePageTargeting(targetingMapping, appName, pageId, datalayer) {
  return _objectSpread(_objectSpread({}, processRequiredMappings(targetingMapping, appName, pageId, datalayer)), processStaticMappings(targetingMapping, appName, pageId));
};

var pageId = function pageId(coreTargeting) {
  return "".concat(coreTargeting.site, ":").concat(coreTargeting.channel, ":").concat(coreTargeting.sect);
};

function generateTargeting(appName, advertTargetingMapping, datalayer) {
  var coreTargeting = generateCoreTargeting(advertTargetingMapping, datalayer);
  var pageTargeting = generatePageTargeting(advertTargetingMapping, appName, pageId(coreTargeting), datalayer);
  return _objectSpread(_objectSpread({}, coreTargeting), pageTargeting);
}

export default generateTargeting;
//# sourceMappingURL=generateTargeting.js.map